<router-outlet></router-outlet>
<div id="refreshToken" class="modal fade qrcode" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content boxs">
            <div class="modal-body boxs">
                <div class="qrcode_scan amount_div boxs">
                    <img src="{{imgUrl + 'img/obsidiam_info_icon.svg'}}" class="img-responsive" alt="qr_code">
                    <label *ngIf="timer" style="position: absolute;right: 13px;top: 7px;">{{timer}}</label>
                    <h5 class="textcolor">Your session is about to expire click yes if you want to continue
                    </h5>
                    <div class="boxs conf_btn">
                        <ul class="yes_lu" style="justify-content:center">
                            <li><a href="javascript:;" class="back_btn no_btn" (click)="logOut()">Logout</a>
                            </li>
                            <li><a href="javascript:;" class="sign_yes no_btn"
                                    (click)="refreshToken()">{{'ip_managment.yes'|translate}}</a></li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="sessionExpiredModal" class="modal fade qrcode" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content boxs">
            <div class="modal-body boxs">
                <div class="qrcode_scan amount_div boxs">
                    <!-- <img src="{{imgUrl + 'img/obsidiam_welcome.png'}}" class="img-responsive" alt="logo"> -->
                    <img src="{{imgUrl + 'img/obsidiam_info_icon.svg'}}" class="img-responsive" alt="logo">
                    <h5 style='font-size: 20px; color:#000;' class="textcolor">{{user.username}}</h5>
                    <h5 style='font-size: 18px;margin: 15px 20px 0px 20px;' class="textcolor">
                        {{'screen_locked_due_to'|translate}}
                    </h5>
                    <!-- <form (ngSubmit)="checkCaptcha()"> -->
                    <div style='align-items: center;margin-top: 30px;justify-content: center;display: flex;flex-direction: column;'
                        class="formstyle boxs">
                        <div style='width: 60%;' class="form-group">
                            <input type="password" name="password" [(ngModel)]="user.password" id="psword"
                                autocomplete="none" class="form-control textcolor req_sec"
                                placeholder="{{ 'login.enter_password' | translate }}" required>
                            <label class="error">{{(errors.password|translate) || '&nbsp;'}}</label>
                        </div>
                        <div class="boxs conf_btn">
                            <ul class="yes_lu" style="justify-content:center">
                                <li><a href="javascript:;" class="back_btn no_btn"
                                        (click)="logOutUserIfUserLoggedIn()">{{'quick_transfer.exit'|translate}}</a>
                                </li>
                                <li><a href="javascript:;" class="sign_yes no_btn"
                                        [ngStyle]="{pointerEvents: isButton? 'none': '', opacity: isButton ? '0.5': '1'}"
                                        (click)="checkCaptcha()">{{'withdraw.submit'|translate}}</a></li>
                            </ul>

                        </div>
                    </div>

                    <!-- </form> -->

                </div>
            </div>
        </div>
    </div>

</div>
<div id="payment-widget"></div>